import React from 'react';
import { ArrowRight, Trophy } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';

const HeroSection = () => {
  const { t } = useTranslation();
  const handleJoinSquad = () => {
    const contactSection = document.querySelector('#contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleViewTournaments = () => {
    const tournamentsSection = document.querySelector('#tournaments');
    if (tournamentsSection) {
      tournamentsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img 
            src={`${process.env.PUBLIC_URL}/images/battlefield-6.jpg`} 
            alt="Battlefield Background"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-70"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-black via-transparent to-transparent"></div>
        </div>

        {/* Content */}
      <div className="container mx-auto px-4 relative z-10 pt-20">
          {/* Logo Section */}
          <div className="flex justify-start items-center">
            <div className="relative">
              <img 
                src={`${process.env.PUBLIC_URL}/images/logo.png`}  
                alt="Club Logo"
                className="w-80 h-80 object-contain filter drop-shadow-2xl bg-transparent"
              />
            </div>
          </div>
        
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8 fade-in-up">
            {/* Club Badge */}
            <div className="flex items-center space-x-3 mb-6">
              <Trophy className="text-yellow-400" size={24} />
              <span className="caption text-yellow-400">
                {t('clubInfo.achievements')} • Est. {t('clubInfo.founded')}
              </span>
            </div>

            {/* Main Headline */}
            <h1 className="brand-display text-primary">
              {t('hero.title')}
            </h1>

            {/* Subtitle */}
            <p className="body-large text-secondary max-w-lg">
              {t('hero.subtitle')}
            </p>

            {/* Club Description */}
            <p className="body-medium text-secondary max-w-xl">
              {t('clubInfo.description')}
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-6">
              <button 
                onClick={handleJoinSquad}
                className="btn-primary group"
              >
                {t('hero.joinTeam')}
                <ArrowRight size={20} className="ml-2 group-hover:translate-x-1 transition-transform" />
              </button>
              
            </div>

            {/* Stats */}
            <div className="flex flex-wrap gap-8 pt-8 border-t border-gray-700">
              <div>
                <div className="heading-3 text-primary">{t('clubInfo.achievements')}</div>
                <div className="caption">{t('clubInfo.achievements_desc')}</div>
              </div>
              <div>
                <div className="heading-3 text-primary">{t('clubInfo.members')}</div>
                <div className="caption">{t('clubInfo.members_desc')}</div>
              </div>
              <div>
                <div className="heading-3 text-primary">{t('clubInfo.winrate')}</div>
                <div className="caption">{t('clubInfo.winrate_desc')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-gray-500 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-primary rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;